import React, { useEffect } from 'react';
import '../styles/Manpowerservice.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaBolt, FaHardHat, FaCogs } from 'react-icons/fa';

import image1 from '../assets/mn9.webp';
import image2 from '../assets/mn10.jpg';
import image3 from '../assets/mn11.jpg';
import parallaxImg from '../assets/wr3.jpg';

const Manpowerservice = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="manpowerservice-container">
      {/* 1. Electrical Services */}
      <div className="manpowerservice-section">
        <div className="manpowerservice-box" data-aos="fade-right">
          <FaBolt className="manpowerservice-icon" />
          <h3>Electrical</h3>
          <p>We provide skilled electrical manpower for industrial, commercial, and residential projects. Our electricians ensure safety, efficiency, and compliance with modern standards—whether it's installation, repair, or full system integration.</p>
        </div>
        <div className="manpowerservice-image" data-aos="fade-left" style={{ backgroundImage: `url(${image1})` }} />
      </div>

      {/* 2. Civil Services */}
      <div className="manpowerservice-section">
        <div className="manpowerservice-image" data-aos="fade-right" style={{ backgroundImage: `url(${image2})` }} />
        <div className="manpowerservice-box" data-aos="fade-left">
          <FaHardHat className="manpowerservice-icon" />
          <h3>Civil</h3>
          <p>Our civil manpower includes masons, site engineers, supervisors, and laborers for construction and infrastructure projects. We support foundations, concrete work, structural installations, and site preparation with utmost reliability and safety.</p>
        </div>
      </div>

      {/* 3. Mechanical Services */}
      <div className="manpowerservice-section">
        <div className="manpowerservice-box" data-aos="fade-right">
          <FaCogs className="manpowerservice-icon" />
          <h3>Mechanical</h3>
          <p>We offer mechanical technicians, fitters, and maintenance experts for machinery installation, repair, and maintenance. Our professionals are trained in industrial systems, plant equipment, and mechanical operations to boost your efficiency.</p>
        </div>
        <div className="manpowerservice-image" data-aos="fade-left" style={{ backgroundImage: `url(${image3})` }} />
      </div>

      <div className="parallax-container">
        <div className="parallax-background" style={{ backgroundImage: `url(${parallaxImg})` }} />
        <div className="parallax-overlay">
          <h1 className="parallax-heading1">SKILLED MANPOWER FOR EVERY INDUSTRY</h1>
        </div>
      </div>
    </div>
  );
};

export default Manpowerservice;
